import React, { useContext } from "react";
import { FilterContext, FilterDefinitions } from "./FilterContext";
import SubLabel from "components/Atoms/Sublabel";

interface Props {
  filterKey: keyof FilterDefinitions;
  showTitle?: boolean
}

const FilterValue = (props: Props) => {
  const filterContext = useContext(FilterContext);

  const renderedFilterValue = filterContext.renderSingleFilterValue(props.filterKey, props.showTitle ?? false);

  if (renderedFilterValue) return <div className="filter-value-row">{renderedFilterValue}</div>;

  return <SubLabel>{RESX.SelectionManager.NoFilter}</SubLabel>
}

export default FilterValue;